const sanitizeNumber = (value: string) => value.replace(/[^\d]+/g, '')

const parseAppno = (value: string) => {
  const sanitized = sanitizeNumber(value)
  return sanitized.length === 8 ? sanitized : ''
}

export default parseAppno
